'use client'

import React from 'react'
import { Outlet } from 'react-router-dom'
import { useTranslations } from '@/lib/next-shim'
import { useSession } from '@/shared/ui/providers/AuthSessionProvider'
import { Header } from './Header'
import { Footer } from './Footer'

type MarketingLayoutProps = {
  children?: React.ReactNode
}

export function MarketingLayout({ children }: MarketingLayoutProps) {
  const t = useTranslations()
  const { data: session } = useSession()

  const sections = [
    { label: t('page.Home.navigation.features'), name: 'features', href: '#features' },
    { label: t('page.Home.navigation.faqs'), name: 'faqs', href: '#faqs' },
  ]

  return (
    <div>
      <Header isAuthenticated={!!session} navMenu={sections} />
      {children || <Outlet />}
      <Footer navMenu={sections} />
    </div>
  )
}
